"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _dateFns = require("date-fns");
var _core = require("core.ui-module_site-components");
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _ApplicationContext = require("../api/ApplicationContext");
var _UserIdChangeForm = _interopRequireDefault(require("./account/UserIdChangeForm"));
var _PasswordChangeForm = _interopRequireDefault(require("./account/PasswordChangeForm"));
var _Profile = require("../api/Profile");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const errorMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "help is-danger"
}, msg);
class LoginInformation extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleUserIdValidation", isValid => {
      if (isValid) {
        this.setState({
          userIdSubmitEnabled: true
        });
      } else {
        this.setState({
          userIdSubmitEnabled: false
        });
      }
    });
    _defineProperty(this, "handlePasswordValidation", isValid => {
      if (isValid) {
        this.setState({
          passwordSubmitEnabled: true
        });
      } else {
        this.setState({
          passwordSubmitEnabled: false
        });
      }
    });
    _defineProperty(this, "OpenModal", () => {
      const user = _SecurityContextHolder.SecurityContextHolder.getCurrentContext();
      _ApplicationContext.ApplicationContext.setContext('currentLoginUserID', user.userId);
      this.setState({
        showModal: true
      });
    });
    _defineProperty(this, "OpenPasswordModal", () => {
      this.setState({
        showPasswordModal: true
      });
    });
    _defineProperty(this, "CloseModal", () => {
      const {
        isLoading
      } = this.state;
      if (isLoading) {
        return;
      }
      this.setState({
        showModal: false,
        showSuccessModal: false
      });
    });
    _defineProperty(this, "ClosePasswordModal", () => {
      const {
        isLoading
      } = this.state;
      if (isLoading) {
        return;
      }
      this.setState({
        showPasswordModal: false,
        showSuccessModal: false
      });
    });
    _defineProperty(this, "disableButton", () => {
      const info = JSON.parse(_ApplicationContext.ApplicationContext.getContext('SecurityContext'));
      if (info.impersonator === null && info?.userType !== 'MARKETINGREP') {
        const buttonVisible = false;
        return buttonVisible;
      }
      const buttonVisible = true;
      return buttonVisible;
    });
    _defineProperty(this, "SubmitModal", () => {
      const {
        isLoading,
        isError
      } = this.state;
      if (isLoading || isError) return;
      const currentLoginUserID = _ApplicationContext.ApplicationContext.getContext('currentLoginUserID');
      this.child.current.onSubmit();
      const {
        userId,
        confirmUserId,
        currentPassword,
        minLength = 8,
        maxLength = 60
      } = this.child.current.state;
      if (userId !== '' && userId.toUpperCase() !== currentLoginUserID.toUpperCase() && confirmUserId !== '' && userId.toUpperCase() === confirmUserId.toUpperCase() && userId.length >= minLength && userId.length <= maxLength && currentPassword !== '') {
        this.setState({
          isLoading: true,
          isError: false
        });
        (0, _Profile.setChangeUserId)(userId, confirmUserId, currentPassword).then(results => {
          this.setState({
            isLoading: false
          });
          if (results.data.successful === true) {
            this.setState({
              showModal: false,
              showSuccessModal: true,
              successModalMessage: results.data.message,
              successModalHeader: 'Success!!'
            });
            _ApplicationContext.ApplicationContext.setContext('newUserId', userId);
          } else {
            this.setState({
              showModal: true,
              showSuccessModal: false
            });
            this.child.current.setState({
              serviceError: results.data.message
            });
          }
        }).catch(() => {
          this.setState({
            isLoading: false,
            isError: true
          });
        });
      }
    });
    _defineProperty(this, "SubmitPasswordModal", () => {
      const {
        isLoading,
        isError
      } = this.state;
      if (isLoading || isError) return;
      this.child.current.onSubmit();
      const {
        secret,
        confirmPassword,
        currentPassword,
        passwordStrength,
        minLength = 10,
        maxLength = 24
      } = this.child.current.state;
      if (secret !== '' && confirmPassword !== '' && secret === confirmPassword && currentPassword !== '' && passwordStrength !== 'Weak' && secret.length >= minLength && secret.length <= maxLength) {
        this.setState({
          isLoading: true,
          isError: false
        });
        (0, _Profile.setChangePassword)(currentPassword, secret, confirmPassword).then(results => {
          this.setState({
            isLoading: false
          });
          if (results.data.successful === true) {
            this.setState({
              showPasswordModal: false,
              showSuccessModal: true,
              successModalMessage: results.data.message,
              successModalHeader: 'Success!!'
            });
          } else {
            this.setState({
              showPasswordModal: true,
              showSuccessModal: false
            });
            if (results.data.message.includes('The specified password does not meet the minimum requirements or may not be one of the last three passwords used.')) {
              this.child.current.setState({
                secretError: errorMessage(results.data.message)
              });
            } else {
              this.child.current.setState({
                currentPasswordError: errorMessage(results.data.message)
              });
            }
          }
        }).catch(() => {
          this.setState({
            isLoading: false,
            isError: true
          });
        });
      }
    });
    this.child = /*#__PURE__*/_react.default.createRef();
    this.el = document.createElement('div');
    this.el.style.display = 'contents';
    this.state = {
      showModal: false,
      showSuccessModal: false,
      successModalMessage: '',
      successModalHeader: '',
      isLoading: false,
      isError: false,
      userIdSubmitEnabled: false,
      passwordSubmitEnabled: false
    };
  }
  componentDidMount() {
    document.body.appendChild(this.el);
  }
  componentWillUnmount() {
    document.body.removeChild(this.el);
  }
  renderModal() {
    const {
      showModal,
      showPasswordModal,
      isLoading,
      isError,
      userIdSubmitEnabled,
      passwordSubmitEnabled
    } = this.state;
    if (showModal) {
      return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_core.Modal, {
        showCloseIcon: false,
        footer: /*#__PURE__*/_react.default.createElement("div", {
          className: "notificationPopup"
        }, /*#__PURE__*/_react.default.createElement("button", {
          type: "submit",
          className: "button is-primary",
          onClick: () => this.CloseModal()
        }, "Cancel"), /*#__PURE__*/_react.default.createElement("button", {
          type: "submit",
          className: isError ? 'button is-disabled is-pulled-right fixedButtonSize' : 'button is-primary is-pulled-right fixedButtonSize',
          onClick: () => this.SubmitModal(),
          disabled: !userIdSubmitEnabled
        }, "Submit")),
        header: "Change User ID"
      }, /*#__PURE__*/_react.default.createElement(_UserIdChangeForm.default, {
        ref: this.child,
        isLoading: isLoading,
        isError: isError,
        handleValidation: this.handleUserIdValidation
      })), this.el);
    }
    if (showPasswordModal) {
      return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-submit"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cpaw"
      }, /*#__PURE__*/_react.default.createElement(_core.Modal, {
        showCloseIcon: false,
        footer: /*#__PURE__*/_react.default.createElement("div", {
          className: "notificationPopup"
        }, /*#__PURE__*/_react.default.createElement("button", {
          type: "submit",
          className: "button is-primary",
          onClick: () => this.ClosePasswordModal()
        }, "Cancel"), /*#__PURE__*/_react.default.createElement("button", {
          type: "submit",
          className: isError ? 'button is-disabled is-pulled-right fixedButtonSize' : 'button is-primary is-pulled-right fixedButtonSize',
          onClick: () => this.SubmitPasswordModal(),
          disabled: !passwordSubmitEnabled
        }, "Submit")),
        header: "Change Password"
      }, /*#__PURE__*/_react.default.createElement(_PasswordChangeForm.default, {
        ref: this.child,
        isLoading: isLoading,
        isError: isError,
        handleValidation: this.handlePasswordValidation
      })))), this.el);
    }
    return null;
  }
  render() {
    const {
      showSuccessModal,
      successModalMessage,
      successModalHeader
    } = this.state;
    const user = _SecurityContextHolder.SecurityContextHolder.getCurrentContext();
    const newUserId = _ApplicationContext.ApplicationContext.getContext('newUserId');
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "box with-border"
    }, this.renderModal(), /*#__PURE__*/_react.default.createElement("div", {
      className: "profile"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title is-3"
    }, "Login Information"), /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle is-4"
    }, "Change User ID/Password"), /*#__PURE__*/_react.default.createElement("div", {
      className: "columns is-desktop is-tablet"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-6"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "columns"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-3"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("b", null, "User ID: "))), /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-8"
    }, newUserId || user.userId)))), /*#__PURE__*/_react.default.createElement("div", {
      className: "columns is-desktop is-tablet"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-6"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "columns"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-3"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("b", null, "Last Login: "))), /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-8"
    }, (0, _dateFns.format)((0, _dateFns.parseISO)(user.lastLogin), 'M/d/yyyy h:mm:ss a')))), /*#__PURE__*/_react.default.createElement("div", {
      className: "column is-6 "
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "buttons"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      className: "button is-primary is-pulled-right",
      onClick: () => this.OpenModal(),
      disabled: this.disableButton()
    }, "Change User ID"), /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      className: "button is-primary is-pulled-right",
      onClick: () => this.OpenPasswordModal(),
      disabled: this.disableButton()
    }, "Change Password"))))), showSuccessModal ? /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-submit"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "cpaw"
    }, /*#__PURE__*/_react.default.createElement(_core.Modal, {
      showCloseIcon: false,
      footer: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "submit",
        className: "button is-primary is-pulled-right fixedButtonSizeHuge",
        onClick: () => this.CloseModal()
      }, "Return to My Profile")),
      header: successModalHeader
    }, /*#__PURE__*/_react.default.createElement("p", null, successModalMessage)))) : null);
  }
}
exports.default = LoginInformation;
//# sourceMappingURL=LoginInformation.js.map